module.exports = __webpack_public_path__ + "img/resource-tech-image-73.65756708.jpg";